<template>
  <div class="home">
    <img alt="logo" id="bigLogo" src="../assets/update.svg">
  </div>
</template>

<script>
  export default {
    name: 'Home',
    title: "Nethanzêl"
  }
</script>

<style lang="scss" scoped>
.home {
    height: 100%;
    width: 100vw;
    display: flex;

    mix-blend-mode: difference; 
    will-change: opacity;
}

img {
  width: 45vw;
  transition: opacity 2s;
  position: fixed;
  top: -9998px;
  bottom: -9998px;
  left: -9998px;
  right: -9998px;
  margin: auto;
  pointer-events: none;
  opacity: 0;
}

.animateZoom {
  animation: zoomIn 2s ease-out, fadeOut .4s linear;
  -webkit-animation-fill-mode: forwards; /* Chrome 16+, Safari 4+ */
  -moz-animation-fill-mode: forwards;    /* FF 5+ */
  -o-animation-fill-mode: forwards;      /* Not implemented yet */
  -ms-animation-fill-mode: forwards;     /* IE 10+ */
  animation-fill-mode: forwards;         /* When the spec is finished */
  

}

@keyframes zoomIn {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(2.5);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@media screen and (max-width: 900px) {
  img {
    width: 65vw;
  }
}

@media screen and (max-width: 500px) {
  img {
    width: 85vw;
  }
}

</style>

